import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=5fa65b54&scoped=true&"
import script from "./addDialog.vue?vue&type=script&lang=js&"
export * from "./addDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa65b54",
  null
  
)

export default component.exports